import { atom } from "jotai";
import type { StorageStatus } from "@/generated";
import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";

export type StorageLevel = StorageStatus["level"];

/** The level whose dialog has been dismissed. Per level, so an escalation from
 * warning to critical interrupts again — and in memory only, so opening the app
 * on a full disk always says so once. */
export const storageDialogDismissedLevelAtom = atom<StorageLevel | null>(null);

export function useStorageStatus() {
  const { data } = useRemoteData(DATA_KEYS.STORAGE_STATUS, {});
  return { status: data };
}
